module.exports = __webpack_public_path__ + "img/person.0ec72080.png";